import React from 'react'
// components
import { Tab } from '@mui/material'
import { Tabs, Scrollbar } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
// constants
import { ENTITIES } from 'constants/index'
// context
import { ActionContext } from 'context/index'
// hocs
import withAction from 'components/Modals/PlanItems/Action/withAction'
// hooks
import { usePlanAccess } from 'hooks/index'
// view components
import ActionActivitiesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ActivitiesList'
import ActionResourcesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ResourcesList'
import ActionReviewsList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ReviewsList'
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import CompleteReviewContainer from 'containers/Review/CompleleReview'
import DetailsSection from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/index'
import ObjectivesListContainer from 'containers/ObjectivesList'
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
// views
import { SubHeader } from 'components/Modals/PlanItems/styles'
import { ActivitiesWrapper } from 'components/Modals/CreateReviewModal/views'
// types
import { LogEntityTypes } from 'types/graphql'

const ActionDetails: React.FC = () => {
  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, plan, update } = React.useContext(ActionContext) as any

  const shouldShowPlan = usePlanAccess(plan)

  const handleSetTab = (_, value) => setTab(value)

  return (
    <>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Plan' />
              <Tab label='Activity' />
              <Tab label='Resources' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <>
              <CompleteAction entity={entity} update={update} />
              <CompleteReviewContainer entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }} />
              <Scrollbar style={{ height: 'calc(100% - 212px)' }}>
                <DetailsSection entity={{ ...entity, entityType: LogEntityTypes.Action }} />
              </Scrollbar>
            </>
          )}

          {tab === 2 && (
            <ActivitiesWrapper>
              <ActionActivitiesList />
            </ActivitiesWrapper>
          )}

          <div style={{ height: 'calc(100% - 50px)' }}>
            {tab === 1 && (shouldShowPlan ? <ObjectivesListContainer plan={plan} /> : <AuthorizationWarning />)}
            {tab === 3 && <ActionResourcesList />}
            {tab === 4 && <ActionReviewsList />}
          </div>
        </>
      )}
    </>
  )
}

export default withAction(ActionDetails)
